import { apiClientWithMiddleware } from '../../../utils/API';
import { captureException } from '../../../utils/sentryAPI';
import { captureUndefinedPortalError, getApiConfigs } from './api-utils';
const NOTIFICATION_STATION_API_V3_URL = 'notification-station/general/v3/notifications';
export const getUnseenNotificationCount = async () => {
  const {
    queryConfig
  } = getApiConfigs();
  if (!queryConfig.query.portalId) {
    captureUndefinedPortalError();
    return 0;
  }
  try {
    const response = await apiClientWithMiddleware().getWithResponse(`notification-station/general/v1/notifications/count`, queryConfig);
    return response.data;
  } catch (e) {
    if (e instanceof Error) {
      captureException(e);
    }
    return 0;
  }
};
export const getUnreadCount = async () => {
  const {
    queryConfig
  } = getApiConfigs();
  if (!queryConfig.query.portalId) {
    captureUndefinedPortalError();
    return {
      counter: 0,
      hasMore: false
    };
  }
  try {
    const response = await apiClientWithMiddleware().getWithResponse(`${NOTIFICATION_STATION_API_V3_URL}/count`, {
      query: {
        portalId: queryConfig.query.portalId,
        show_unread_only: true
      }
    });
    return response.data;
  } catch (e) {
    if (e instanceof Error) {
      captureException(e);
    }
    return {
      counter: 0,
      hasMore: false
    };
  }
};